const DEFAULT_STREAM_ID = 1;
const DEFAULT_RELAY_PROTOCOL = "ws";

/**
 * Falcon / viewing-controller WebSocket endpoint.
 * Prefer REACT_APP_FALCON_URL; fall back to REACT_APP_WEBSOCKET_URL when unset.
 */
export function getFalconEndpoint() {
  const explicit = process.env.REACT_APP_FALCON_URL;
  if (explicit) return explicit;

  const portalWs = process.env.REACT_APP_WEBSOCKET_URL;
  if (!portalWs) return "";

  try {
    const url = new URL(portalWs);
    return `${url.protocol}//${url.host}/ws`;
  } catch {
    return "";
  }
}

export function getRelayProtocol(falconEndpoint) {
  if (!falconEndpoint) return DEFAULT_RELAY_PROTOCOL;
  return falconEndpoint.startsWith("wss:") ? "wss" : "ws";
}

/**
 * Extract stream playback fields from a device API `info` object.
 * Extend keys here when the backend contract is finalized.
 */
export function mapDeviceStreamFields(info = {}) {
  const streamIdRaw = info.streamId ?? info.defaultStreamId;
  const streamId = Number.isInteger(streamIdRaw) ? streamIdRaw : DEFAULT_STREAM_ID;

  return {
    accessToken:
      info.streamAccessToken ||
      info.viewingAccessToken ||
      info.accessToken ||
      "",
    streamId,
    falconEndpoint: info.falconEndpoint || info.streamEndpoint || "",
    relayProtocol: info.relayProtocol || "",
  };
}

/**
 * Resolve playback config for one camera.
 * Priority: per-device API fields → portal auth token → optional dev env override.
 *
 * After executeSurveillanceCommand returns a stream URL, use extractViewingStreamUrl()
 * in startViewingCommand.js and pass it as falconEndpoint here.
 */
export function resolveStreamConfig({ device, authToken } = {}) {
  const fromDevice = device ? mapDeviceStreamFields(device) : {};
  const falconEndpoint = fromDevice.falconEndpoint || getFalconEndpoint();
  const relayProtocol =
    fromDevice.relayProtocol || getRelayProtocol(falconEndpoint);
  const accessToken =
    fromDevice.accessToken ||
    authToken ||
    process.env.REACT_APP_LIVEVIEW_DEV_ACCESS_TOKEN ||
    "";
  const streamId = fromDevice.streamId || DEFAULT_STREAM_ID;

  return {
    falconEndpoint,
    relayProtocol,
    accessToken,
    streamId,
  };
}
